import React, { useEffect, useState } from 'react';
import clientService from '../../../services/clientService';
import { Users, Briefcase, CheckCircle, Activity, TrendingUp } from 'lucide-react';

const ClientsStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      setLoading(true);
      const s = await clientService.getStatistics();
      setStats(s);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="p-10 text-center">Loading...</div>;
  if (!stats) return null;

  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-primary mb-2">Clients Statistics</h1>
        <p className="text-gray-600">Overall agency metrics</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Total Clients</p>
          <p className="text-4xl font-bold text-primary mt-2">{stats.total_clients}</p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Active Clients</p>
          <p className="text-4xl font-bold text-green-600 mt-2">{stats.active_clients}</p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Inactive Clients</p>
          <p className="text-4xl font-bold text-gray-600 mt-2">{stats.inactive_clients}</p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Active Projects</p>
          <p className="text-4xl font-bold text-blue-600 mt-2">{stats.active_projects}</p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Completed Projects</p>
          <p className="text-4xl font-bold text-purple-600 mt-2">{stats.completed_projects}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Total Revenue</p>
          <p className="text-4xl font-bold text-green-600 mt-2">฿{Number(stats.total_revenue||0).toLocaleString()}</p>
        </div>
        <div className="bg-white rounded-xl shadow-md p-6">
          <p className="text-gray-500 text-sm">Pending Payments</p>
          <p className="text-4xl font-bold text-orange-600 mt-2">฿{Number(stats.pending_payments||0).toLocaleString()}</p>
        </div>
      </div>

      <div className="mt-8">
        <button onClick={load} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded-lg">Refresh</button>
      </div>
    </div>
  );
};

export default ClientsStats;
